'use client';

import BackgroundVideo from '@/components/background-video';

import ctaPoster from '@images/cta-poster.webp';

// CTA(문의영역) 배경 영상 — 공용 BackgroundVideo에 CTA 파라미터 주입(1920/960).
export default function CtaBackgroundVideo({
  className,
}: {
  className?: string;
}) {
  return (
    <BackgroundVideo
      poster={ctaPoster}
      name="cta"
      wideRes="1920"
      narrowRes="960"
      className={className}
    />
  );
}
